import React from 'react';
import { useFormContext } from 'react-hook-form';
import Textarea, { TextareaProps } from './Textarea';

const FormTextarea: React.FC<TextareaProps> = props => <Textarea {...props} {...useFormContext()} />;

export default FormTextarea;
